import '../styles/main.scss';
import FetchCarousel from './modules/FetchCarousel';

(($) => {
  $(document).ready(() => {
    ga('create', 'UA-296593-9', 'auto');

    const mainCarousel = new FetchCarousel(document.querySelector('[data-fetch-slider]'));
    mainCarousel.init();

    $('.initial-loader').fadeOut();
  });
})(jQuery);

/* istanbul ignore if */
if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// local_static/templates/volei/2018/assets/scripts/main.js